"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailAddressFactory = void 0;
const Factory = require("factory.ts");
exports.emailAddressFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    address: 'test@example.com',
    is_primary: true,
    is_validated: true,
});
